var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"options":_vm.options,"multiple":false,"searchable":false,"show-labels":false,"allow-empty":false,"max-height":180,"track-by":"value","label":"name","data-cy":"select-report-frequency"},model:{value:(_vm.selectedFrequency),callback:function ($$v) {_vm.selectedFrequency=$$v},expression:"selectedFrequency"}})
}
var staticRenderFns = []

export { render, staticRenderFns }